import {
  FETCH_SKILLS_START,
  FETCH_SKILLS_SUCCESS,
  FETCH_SKILLS_ERROR,
  GET_CATEGORIES_SUCCESS
} from "../actions/skills.actions";

const INITIAL_STATE = {
  skills: [],
  isLoading: false,
  categories: []
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case FETCH_SKILLS_START:
      return { ...state, isLoading: true };
    case FETCH_SKILLS_SUCCESS:
      return { ...state, skills: action.data, isLoading: false };
    case FETCH_SKILLS_ERROR:
      return { ...state, isLoading: false };
    case GET_CATEGORIES_SUCCESS:
      return { ...state, categories: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/skills.reducer.js